module.exports = __webpack_public_path__ + "img/ContentPasteOutlined.50128d69.svg";